<script setup>
// Campo rotulado da aba "Ligações SIP (PABX)": label + slot (input/select) + dica.
defineProps({
  label: { type: String, required: true },
  hint: { type: String, default: '' },
});
</script>

<template>
  <label class="flex flex-col gap-1 text-sm font-medium text-n-slate-12">
    {{ label }}
    <slot />
    <span v-if="hint" class="text-xs font-normal text-n-slate-10">
      {{ hint }}
    </span>
  </label>
</template>
